import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Stack, Typography, Slider, Grid, Box } from '@mui/material';
import classes from '../constants/gradientBar.module.css';

interface SliderBoxProps {
  target: any;
  initialValue?: number;
  onOpacityChange?: (value: number) => void;
}

const GradientBar = () => {
  // グラデーションのスタイルを定義
  const [t] = useTranslation();

  return (
    <Grid container spacing={1}>
      <Grid item>
        <Typography style={{ fontSize: '10pt' }}>{t('common.label.floodDepth')}</Typography>
      </Grid>
      <Grid item>
        <div style={{ height: '20px', position: 'relative', width: '170px' }}>
          <div className={classes.gradient} />
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
            }}
          >
            <Typography style={{ fontSize: '10pt' }}>0m</Typography>
            <Typography style={{ fontSize: '10pt' }}>8m</Typography>
          </div>
        </div>
      </Grid>
    </Grid>
  );
};


const SliderBox: React.FC<SliderBoxProps> = ({ target, initialValue = 0.7, onOpacityChange }) => {
  // 言語切り替え
  const [t] = useTranslation();
  const [value, setValue] = useState<number>(initialValue);

  const handleChange = (e: any) => {
    if (!target) {
      return;
    }
    const newValue = parseFloat(e.target.value);
    target.setOpacity(newValue);
    setValue(newValue);
    if (onOpacityChange) {
      onOpacityChange(newValue);
    }
  };

  useEffect(() => {
    setValue(initialValue);
  }, [target, initialValue]);

  return (
    <Stack>
      <Typography sx={{ fontSize: 12, fontWeight: 'bold', textShadow: '0 1px 2px #333', color: '#fff', mb: 1 }}>{t('common.label.transmittance')}</Typography>

      <Box sx={{
        backgroundColor: '#fff',
        borderRadius: '4px',
        border: '1px solid #ccc',
        padding: '4px 24px 12px 16px',
      }}>
        <Slider
          value={value}
          onChange={handleChange}
          min={0}
          max={1}
          step={0.1}
          sx={{
            width: 100,
            padding: 0,
          }}
          disabled={!(target)}
        />
      </Box>
    </Stack>
  );
};

export default SliderBox;
